var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Card',[_c('ui-copy-input',{attrs:{"label":"Input label"},model:{value:(_vm.testUrl),callback:function ($$v) {_vm.testUrl=$$v},expression:"testUrl"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }